import MyPage from './myPage'

const myPage = {
  install(Vue) {
    Vue.component(MyPage.name, MyPage)
  }
}

export default myPage